import * as React from "react";
import styled, { css } from "styled-components";
import {
  ITableProps,
  Table,
  OrderingColumn,
  OrderingDirection,
} from "../../../utils/Pagination/NumberedPagination/table";

const TableContainer = styled.div`
  overflow-x: auto;
`;

const UsersTableContainer = styled.div(
  ({ theme }) => `
    width: 100%;
  
    font-family: ${theme.primaryTheme.primaryFontFamily};
    font-size: ${theme.primaryTheme.primaryFontSize};
  `
);

const centeredText = css`
  text-align: center;
`;

export interface IUserRow {
  checked: React.ReactElement;
  learnerName: string;
  state: React.ReactElement;
  dateLastSeen: string;
  resets: number;
  time: string;
  topics: number;
}

interface IUserPageTableProps {
  data: IUserRow[];
  isFilteredOutRow: boolean[];
  sortingFns: Array<() => void>;
  ordering: [OrderingColumn, OrderingDirection];
  allSelected: boolean;
}

const UsersTable: React.FC<ITableProps<IUserRow>> = ({
  columns,
  data,
  sortingFns,
  isFilteredOutRow,
  ordering,
  allSelected,
}) => {
  return (
    <TableContainer>
      <Table
        columns={columns}
        data={data}
        sortingFns={sortingFns}
        isFilteredOutRow={isFilteredOutRow}
        ordering={ordering}
        allSelected={allSelected}
      />
    </TableContainer>
  );
};

const UsersPageTable: React.FC<IUserPageTableProps> = ({
  data,
  sortingFns,
  isFilteredOutRow,
  ordering,
  allSelected,
}) => {
  return (
    <UsersTableContainer data-testid="users-table">
      <UsersTable
        columns={[
          { name: "Select", accessor: "checked", styles: centeredText },
          { name: "Learner Name", accessor: "learnerName" },
          { name: "State", accessor: "state", styles: centeredText },
          { name: "Last Seen", accessor: "dateLastSeen" },
          { name: "Resets", accessor: "resets", styles: centeredText },
          { name: "Time Taken", accessor: "time", styles: centeredText },
          { name: "# Lessons", accessor: "topics", styles: centeredText },
        ]}
        data={data}
        sortingFns={sortingFns}
        isFilteredOutRow={isFilteredOutRow}
        ordering={ordering}
        allSelected={allSelected}
      />
    </UsersTableContainer>
  );
};

export default UsersPageTable;
